// "Show Overdue Tasks Only" checkbox shared by the Personal Campaign views.
export const OverdueToggle = ({ checked, onChange, count, testid = "pc-overdue-toggle" }) => (
  <div data-testid={`${testid}-wrap`} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 12, color: "#334155" }}>
    <label style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer", userSelect: "none" }}>
      <input type="checkbox" data-testid={testid} checked={checked} onChange={(e) => onChange(e.target.checked)}
        style={{ width: 14, height: 14, accentColor: "#2563eb", cursor: "pointer" }} />
      Show Overdue Tasks Only
    </label>
    {count !== undefined && (
      <span data-testid={`${testid}-count`} style={{
        padding: "1px 8px", borderRadius: 999, fontSize: 10, fontWeight: 600,
        background: checked ? "#FEE2E2" : "#DBEAFE", color: checked ? "#B91C1C" : "#1D4ED8",
      }}>{count === null ? "…" : `${count} ${checked ? "overdue" : "due today"}`}</span>
    )}
  </div>
);

export const viewOf = (overdue) => (overdue ? "overdue" : "today");
